import { themeColors } from 'src/theme/schemes/PureLightTheme';

export const getStatusColor = (status: string): string => {
  switch (status) {
    case 'pending': {
      return themeColors.blue;
    }
    case 'error': {
      return themeColors.error;
    }
    case 'running': {
      return themeColors.blue;
    }
    case 'success': {
      return themeColors.success;
    }
    case 'timeout': {
      return '#ff9100ff';
    }
  }
};
